import React, { useState, useEffect } from "react"
import { get } from 'lodash'
import { makeStyles } from "@material-ui/core"
import LocalOfferIcon from '@material-ui/icons/LocalOffer'
import { CurrencyValue } from './CurrencyValue'
import { countryList } from '../v2_actions/country'

const useStyles = makeStyles({
    tile: {
        position: "relative",
        height: 220,
        borderRadius: 10,
        overflow: "hidden",
        cursor: "pointer",
        background: "#f3f3ef",
        flexShrink: 0,
        transition: "transform .15s, box-shadow .15s",
        "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: "0 6px 18px -8px rgba(11,53,86,0.18), 0 1px 2px rgba(11,53,86,0.06)",
        },
        "&:hover $actions": {
            opacity: 1,
            transform: "translate(-50%, 0)",
        },
        "&:hover $grad": {
            opacity: 1,
        },
        "&:hover $photoName": {
            opacity: 1,
        },
        "&:hover $imgInner": {
            transform: "scale(1.04)",
        },
    },
    tileSelected: {
        outline: "3px solid #3a86d8",
        outlineOffset: -3,
        "& $actions": {
            opacity: 1,
            transform: "translate(-50%, 0)",
        },
        "& $grad": {
            opacity: 1,
        },
        "& $photoName": {
            opacity: 1,
        },
        "& $selRing": {
            background: "#3a86d8",
            borderColor: "#3a86d8",
        },
        "& $selCheck": {
            opacity: 1,
        },
    },
    imgWrapper: {
        height: "100%",
        overflow: "hidden",
        lineHeight: 0,
    },
    imgInner: {
        height: "100%",
        display: "block",
        transition: "transform .4s",
    },
    grad: {
        position: "absolute",
        left: 0,
        right: 0,
        bottom: 0,
        height: "50%",
        background: "linear-gradient(180deg, transparent 0%, rgba(0,0,0,0.5) 100%)",
        opacity: 0,
        transition: "opacity .15s",
    },
    actions: {
        position: "absolute",
        top: 8,
        left: "50%",
        transform: "translate(-50%, -8px)",
        display: "flex",
        alignItems: "center",
        gap: 0,
        background: "rgba(20,28,40,0.78)",
        backdropFilter: "blur(6px)",
        border: "1px solid rgba(255,255,255,0.12)",
        borderRadius: 999,
        padding: 4,
        opacity: 0,
        transition: "opacity .15s, transform .15s",
        zIndex: 5,
    },
    actionBtn: {
        width: 30,
        height: 30,
        borderRadius: "50%",
        display: "grid",
        placeItems: "center",
        color: "#fff",
        transition: ".12s",
        border: 0,
        background: "transparent",
        cursor: "pointer",
        padding: 0,
        position: "relative",
        fontFamily: "inherit",
        "&:hover": {
            background: "rgba(255,255,255,0.18)",
        },
    },
    actionBtnDel: {
        "&:hover": {
            background: "#c23a3a",
            color: "#fff",
        },
    },
    actionBtnStarOn: {
        color: "#f5b942",
        "&:hover": {
            background: "rgba(245,185,66,0.2)",
        },
    },
    selBtn: {
        background: "transparent",
    },
    selRing: {
        width: 16,
        height: 16,
        borderRadius: "50%",
        border: "1.5px solid #fff",
        display: "grid",
        placeItems: "center",
    },
    selCheck: {
        opacity: 0,
        transition: "opacity .12s",
    },
    actionDiv: {
        width: 1,
        height: 18,
        background: "rgba(255,255,255,0.18)",
        margin: "0 4px",
    },
    priceForm: {
        display: "flex",
        alignItems: "center",
        gap: 0,
        height: 30,
        padding: "0 10px",
        borderRadius: 999,
        background: "rgba(255,255,255,0.10)",
        transition: "background .12s, box-shadow .12s",
        "&:focus-within": {
            background: "#fff",
            color: "#0b3556",
            boxShadow: "0 0 0 2px #3a86d8",
        },
    },
    priceInput: {
        width: 44,
        minWidth: 0,
        border: 0,
        outline: 0,
        background: "transparent",
        color: "#fff",
        fontFamily: '"JetBrains Mono", ui-monospace, Menlo, monospace',
        fontSize: 12,
        fontWeight: 600,
        padding: 0,
        margin: 0,
        textAlign: "center",
        fontVariantNumeric: "tabular-nums",
        MozAppearance: "textfield",
        "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
            WebkitAppearance: "none",
            margin: 0,
        },
        "$priceForm:focus-within &": {
            color: "#0b3556",
        },
    },
    photoName: {
        position: "absolute",
        left: 10,
        right: 10,
        bottom: 8,
        fontFamily: '"JetBrains Mono", ui-monospace, Menlo, monospace',
        fontSize: 11,
        color: "rgba(255,255,255,0.95)",
        letterSpacing: "0.04em",
        opacity: 0,
        transition: "opacity .15s",
        textShadow: "0 1px 2px rgba(0,0,0,0.4)",
    },
    soldBadge: {
        position: "absolute",
        top: 6,
        left: 6,
        backgroundColor: "#3a86d8",
        color: "white",
        borderRadius: "50%",
        width: 24,
        height: 24,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 6,
    },
    starBadge: {
        position: "absolute",
        top: 8,
        right: 8,
        width: 28,
        height: 28,
        borderRadius: "50%",
        background: "rgba(20,28,40,0.78)",
        backdropFilter: "blur(6px)",
        display: "grid",
        placeItems: "center",
        color: "#f5b942",
        zIndex: 4,
    },
    missingPhoto: {
        position: "absolute",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
        textAlign: "center",
        fontSize: 12,
        color: "#7a7a76",
        background: "#f3f3ef",
    },
})

const TrashSvg = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 6h18" /><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <line x1="10" y1="11" x2="10" y2="17" /><line x1="14" y1="11" x2="14" y2="17" />
  </svg>
)

const StarSvg = ({ filled }) => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill={filled ? "currentColor" : "none"} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
)

const EyeSvg = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" />
  </svg>
)

const CheckSvg = () => (
  <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
)

export const GalleryPhotograph = ({
    index,
    photo,
    margin,
    direction,
    top,
    left,
    country_id,
    getIsSelected,
    getIsActivated,
    isMapPhotograph,
    showSoldIcons,
    onActivatePhotograph,
    onSelectPhotograph,
    onEditPhotograph,
    onSavePrice,
    onUnSelectPhotograph,
    onSetAsMapPhotograph,
    onDeletePhotograph,
    onDeletePhotographWithoutGallerySizeFileInfo
}) => {

    const classes = useStyles()
    const isSelected = getIsSelected(photo)
    const isActivated = getIsActivated(photo)
    const country = countryList.getCountryForId(country_id)
    const [markedForDelete, setMarkedForDelete] = useState(false)
    const [priceValue, setPriceValue] = useState(get(photo, "price", ""))
    const photograph_info = Object.assign({},
                                          get(photo, "gallery_size_file_info", {}),
                                          { height_pixels: 'auto' })

  useEffect(() => {
    if (photograph_info && photograph_info.download_url == null) {
      setMarkedForDelete(true)
    }
  }, [photo])

  useEffect(() => {
    if (markedForDelete) {
      onDeletePhotographWithoutGallerySizeFileInfo(photo)
    }
  }, [markedForDelete])

  useEffect(() => {
    setPriceValue(get(photo, "price", ""))
  }, [get(photo, "price")])

  const onTogglePhotographSelected = () => {
    if (isSelected) {
      onUnSelectPhotograph(photo)
    } else {
      onSelectPhotograph(photo)
    }
  }

  const handlePriceSubmit = (e) => {
    e.preventDefault()
    onSavePrice(photo, priceValue)
    e.target.querySelector('input').blur()
  }

  const tileClass = `${classes.tile} ${isSelected ? classes.tileSelected : ""}`

  return (
    <div
      className={tileClass}
      onMouseEnter={() => onActivatePhotograph(photo)}
      onMouseLeave={() => onActivatePhotograph(null)}
      onClick={onTogglePhotographSelected}
    >
      {get(photo, "gallery_size_file_info") ? (
        <div className={classes.imgWrapper}>
          <img
            src={get(photo, ["gallery_size_file_info", "download_url"])}
            className={classes.imgInner}
            alt={get(photo, "photo_name", "")}
          />
        </div>
      ) : (
        <div className={classes.missingPhoto}>
          <div>{get(photo, "photo_name")}</div>
          Still resizing and adding watermarks, retry in a few minutes.
        </div>
      )}

      <div className={classes.grad} />

      {showSoldIcons && get(photo, "purchased_trolley_photographs", []).length > 0 && (
        <div className={classes.soldBadge}>
          <LocalOfferIcon style={{ fontSize: 16 }} />
        </div>
      )}

      {isMapPhotograph && (
        <div className={classes.starBadge}>
          <StarSvg filled />
        </div>
      )}

      <div className={classes.actions} onClick={(e) => e.stopPropagation()}>
        <button
          className={`${classes.actionBtn} ${classes.actionBtnDel}`}
          onClick={() => onDeletePhotograph(photo)}
          title="Delete"
        >
          <TrashSvg />
        </button>
        <button
          className={`${classes.actionBtn} ${isMapPhotograph ? classes.actionBtnStarOn : ""}`}
          onClick={() => onSetAsMapPhotograph(photo)}
          title="Star"
        >
          <StarSvg filled={isMapPhotograph} />
        </button>
        <button
          className={classes.actionBtn}
          onClick={() => onEditPhotograph(photo)}
          title="View"
        >
          <EyeSvg />
        </button>
        <button
          className={`${classes.actionBtn} ${classes.selBtn}`}
          onClick={onTogglePhotographSelected}
          title="Select"
        >
          <span className={classes.selRing}>
            <span className={classes.selCheck}><CheckSvg /></span>
          </span>
        </button>
        <span className={classes.actionDiv} />
        <form className={classes.priceForm} onSubmit={handlePriceSubmit} onClick={(e) => e.stopPropagation()}>
          <input
            type="number"
            min="0"
            step="1"
            value={priceValue}
            onChange={(e) => setPriceValue(e.target.value)}
            className={classes.priceInput}
            aria-label="Price"
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => {
              if (e.key === "Escape") {
                setPriceValue(get(photo, "price", ""))
                e.target.blur()
              }
            }}
          />
        </form>
      </div>

      <div className={classes.photoName}>{get(photo, "photo_name", "")}</div>
    </div>
  )
}
